import { Button } from '@approvalmax/ui/src/components';
import { FC, memo, useMemo } from 'react';

import { Body, Description, Foot, Head, Icon, Root, Title } from './AppStateScreen.styles';
import { AppStateScreenProps } from './AppStateScreen.types';

const AppStateScreen: FC<AppStateScreenProps> = memo((props) => {
    const { icon, title, description, button } = props;

    const actions = useMemo(() => {
        if (button) {
            return typeof button === 'function' ? (
                button()
            ) : (
                <Button color='blue80' onClick={button.onClick}>
                    {button.text}
                </Button>
            );
        }

        return null;
    }, [button]);

    return (
        <Root>
            <Head>
                <Icon>{icon}</Icon>

                <Title>{title}</Title>
            </Head>

            {description && (
                <Body>
                    <Description>{description}</Description>
                </Body>
            )}

            {button && <Foot>{actions}</Foot>}
        </Root>
    );
});

export default AppStateScreen;
